import { parseHexRgba } from "./color-utils";
import type { BakeResult } from "./types";

/**
 * Expand opaque silhouette by 1px and paint rim color on new edge pixels.
 */
export function applyAffiliationRim(
  baked: BakeResult,
  rimHex: string,
): BakeResult {
  const { width: w, height: h, rgba } = baked;
  const rim = parseHexRgba(rimHex);
  const out = new Uint8ClampedArray(rgba);
  const opaque = (i: number) => rgba[i * 4 + 3]! > 0;

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const i = y * w + x;
      if (opaque(i)) continue;
      let neighbor = false;
      for (const [dx, dy] of [
        [1, 0],
        [-1, 0],
        [0, 1],
        [0, -1],
      ] as const) {
        const nx = x + dx;
        const ny = y + dy;
        if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;
        if (opaque(ny * w + nx)) {
          neighbor = true;
          break;
        }
      }
      if (!neighbor) continue;
      const o = i * 4;
      out[o] = rim.r;
      out[o + 1] = rim.g;
      out[o + 2] = rim.b;
      out[o + 3] = rim.a;
    }
  }
  return { width: w, height: h, rgba: out };
}
